import { render, staticRenderFns } from "./RecieveShippment.vue?vue&type=template&id=944d08b2&scoped=true"
import script from "./RecieveShippment.vue?vue&type=script&lang=js"
export * from "./RecieveShippment.vue?vue&type=script&lang=js"
import style0 from "./RecieveShippment.vue?vue&type=style&index=0&id=944d08b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944d08b2",
  null
  
)

export default component.exports